import TemplatePage from "../templatePage/templatePage";
import MainPage from "./MainPage";

const HomePage = () => {
  return <TemplatePage component={<MainPage />} />;
};

export default HomePage;